/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 18th February 2019
 *
 *  Portal Header
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';

// Components
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import SignOutIcon from '@material-ui/icons/PowerSettingsNewRounded';
import PersonIcon from '@material-ui/icons/PersonRounded';
import StoreIcon from '@material-ui/icons/Store';
import BadgeHistoryIcon from '@material-ui/icons/Assignment';
import ToolTip from '@material-ui/core/Tooltip';

import Menu from '@material-ui/core/Menu';
//import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Fade from '@material-ui/core/Fade';

import Typography from '@material-ui/core/Typography';
import AvatarInput from 'components/InputFields/HeaderAvatarInput';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';

import { StoreContext } from 'stores/RootStore';

const darkThemeLogo = require('assets/images/vb-logo-horizontal-white.png');
const lightThemeLogo = require('assets/images/vbshield.png');

/**
 * TODO: Props for Header
 *
 * Message Count: number
 * Alert Count: number/
 * User Type: string
 * User Company Id: uuid
 */

class Header extends React.Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    //Init app level state
    this.state = {
      anchorEl: null,
      mobileMoreAnchorEl: null,
      isMenuOpen: false,
      isMobileMenuOpen: false,
    };

    // Bindings
    this.handleProfileMenuOpen = this.handleProfileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
  }

  handleProfileMenuOpen(event) {
    this.setState({
      anchorEl: event.currentTarget,
      isMenuOpen: true,
    });
  }

  handleMobileMenuClose() {
    this.setState({
      mobileMoreAnchorEl: null,
      isMobileMenuOpen: false,
    });
  }

  handleMenuClose() {
    this.setState({
      anchorEl: null,
      isMenuOpen: false,
    });
    this.handleMobileMenuClose();
  }

  handleMobileMenuOpen(event) {
    this.setState({
      mobileMoreAnchorEl: event.currentTarget,
      isMobileMenuOpen: true,
    });
  }

  handleSignOut = event => {
    this.handleMenuClose();
    this.context.authStore.signOut();
  };

  handleGoToUserProfile = () => {
    this.props.history.push('/profile');
  };

  handleGoToProfile = () => {
    const { isCompanyUser, isLocationUser } = this.context.authStore;
    isCompanyUser
      ? this.props.history.push('/company/profile')
      : isLocationUser
      ? this.props.history.push(`/location/${this.context.locationStore.locationId}/profile`)
      : this.props.history.push('/profile');
  };

  handleGoToBadgeHistory = () => {
    const { isCompanyUser, isLocationUser } = this.context.authStore;
    isCompanyUser
      ? this.props.history.push('/company/badge-history')
      : isLocationUser
      ? this.props.history.push(`/location/${this.context.locationStore.locationId}/badge-history`)
      : this.props.history.push('/badge-history');
  };

  render() {
    const { classes, theme } = this.props;
    const stores = this.context;
    const user = stores.userStore.user;
    const { isCompanyUser, isLocationUser, isVendorUser } = stores.authStore;
    const locationId = stores.locationStore.locationId;

    // Dynamic Logo based on theme type
    const logo = () => (theme.palette.type === 'dark' ? darkThemeLogo : lightThemeLogo);

    const renderMenu = (
      <Menu
        anchorEl={this.state.anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={this.state.isMenuOpen}
        onClose={this.handleMenuClose}
        TransitionComponent={Fade}
        style={{ margin: 0, padding: 0 }}
        autoFocus={false}
      >
        <ListItem className={classes.menuItem}>
          <Grid container direction='column' justify='center' alignItems='center' className={classes.avatarWrapper}>
            <AvatarInput required url={user.avatarUrl || ''} handleAvatarChange={stores.userStore.handleAvatarChange} />
            <Typography className={classes.changeText}>change</Typography>
          </Grid>
          <Grid container direction='column' justify='flex-end' className={classes.userProfileWrapper}>
            <Typography className={classes.companyName}>{stores.companyStore.company.name}</Typography>
            <Typography className={classes.userName}>{user.displayName}</Typography>
            <Typography className={classes.userEmail}>{user.email}</Typography>
          </Grid>
        </ListItem>
        {isVendorUser ? null : (
          <div>
            <Divider className={classes.sectionDivider} />
            <MenuItem className={classes.menuItem} onClick={this.handleGoToProfile}>
              <ListItemIcon>
                <StoreIcon color='inherit' className={classes.avatarIcon} />
              </ListItemIcon>
              <ListItemText primary={(isCompanyUser ? 'Company' : 'Location') + ' Profile'} />
            </MenuItem>
          </div>
        )}
        <Divider className={classes.sectionDivider} />
        <MenuItem className={classes.menuItem} onClick={this.handleGoToUserProfile}>
          <ListItemIcon>
            <PersonIcon color='inherit' className={classes.avatarIcon} />
          </ListItemIcon>
          <ListItemText primary='My Profile' />
        </MenuItem>
        <Divider className={classes.sectionDivider} />
        <MenuItem className={classes.menuItem} onClick={this.handleSignOut}>
          <ListItemIcon>
            <SignOutIcon />
          </ListItemIcon>
          <ListItemText primary='Sign Out' />
        </MenuItem>
        <Divider className={classes.sectionDivider} />
      </Menu>
    );

    const renderMobileMenu = (
      <Menu
        anchorEl={this.state.mobileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={this.state.isMobileMenuOpen}
        onClose={this.handleMenuClose}
      >
        <ListItem className={classes.menuItem}>
          <Grid container direction='column' justify='center' alignItems='center' className={classes.avatarWrapper}>
            <AvatarInput required url={user.avatarUrl || ''} handleAvatarChange={stores.userStore.handleAvatarChange} />
            <Typography className={classes.changeText}>change</Typography>
          </Grid>
          <Grid container direction='column' justify='flex-end' className={classes.userProfileWrapper}>
            <Typography className={classes.companyName}>{stores.companyStore.company.name}</Typography>
            <Typography className={classes.userName}>{user.displayName}</Typography>
            <Typography className={classes.userEmail}>{user.email}</Typography>
          </Grid>
        </ListItem>
        <Divider className={classes.sectionDivider} />
        <MenuItem className={classes.menuItem} onClick={this.handleGoToBadgeHistory}>
          <ListItemIcon>
            <BadgeHistoryIcon color='inherit' className={classes.avatarIcon} />
          </ListItemIcon>
          <ListItemText primary={'Badge History'} />
        </MenuItem>
        {isVendorUser ? null : (
          <div>
            <Divider className={classes.sectionDivider} />
            <MenuItem className={classes.menuItem} onClick={this.handleGoToProfile}>
              <ListItemIcon>
                <StoreIcon color='inherit' className={classes.avatarIcon} />
              </ListItemIcon>
              <ListItemText primary={(isCompanyUser ? 'Company' : 'Location') + ' Profile'} />
            </MenuItem>
          </div>
        )}
        <Divider className={classes.sectionDivider} />
        <MenuItem className={classes.menuItem} onClick={this.handleGoToUserProfile}>
          <ListItemIcon>
            <PersonIcon color='inherit' className={classes.avatarIcon} />
          </ListItemIcon>
          <ListItemText primary='My Profile' />
        </MenuItem>
        <Divider className={classes.sectionDivider} />
        <MenuItem className={classes.menuItem} onClick={this.handleSignOut}>
          <ListItemIcon>
            <SignOutIcon />
          </ListItemIcon>
          <ListItemText primary='Sign Out' />
        </MenuItem>
        <Divider className={classes.sectionDivider} />
      </Menu>
    );

    return (
      <div className={classes.root}>
        <AppBar position='static' color='secondary' className={classes.appBar}>
          <Toolbar>
            <Link to='/'>
              <img alt='Home' src={logo()} />
            </Link>
            <div className={classes.grow}></div>
            <div className={classes.sectionDesktop}>
              <ToolTip title={'Badge History'}>
                <IconButton
                  color='inherit'
                  className={classes.avatarButton}
                  aria-label='Badge History'
                  component={Link}
                  to={
                    isCompanyUser
                      ? '/company/badge-history'
                      : isLocationUser
                      ? `/location/${locationId}/badge-history`
                      : `/badge-history`
                  }
                >
                  <BadgeHistoryIcon className={classes.headerIcon} />
                </IconButton>
              </ToolTip>
              <ToolTip title={'Settings'}>
                <IconButton
                  aria-owns={this.state.isMenuOpen ? 'material-appbar' : undefined}
                  aria-haspopup='true'
                  onClick={this.handleProfileMenuOpen}
                  className={classes.avatarButton}
                >
                  {user.avatarUrl !== undefined && user.avatarUrl !== '' ? (
                    <Avatar alt='My Avatar' src={user.avatarUrl} className={classes.avatar} />
                  ) : user.initials !== '' ? (
                    <Avatar alt='My Avatar' className={classes.avatarInitials}>
                      {user.initials}
                    </Avatar>
                  ) : (
                    <PersonIcon color='inherit' className={classes.avatarIcon} />
                  )}
                </IconButton>
              </ToolTip>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-owns={this.state.isMobileMenuOpen ? 'material-appbar' : undefined}
                aria-haspopup='true'
                onClick={this.handleMobileMenuOpen}
                className={classes.avatarButton}
              >
                {user.avatarUrl !== undefined && user.avatarUrl !== '' ? (
                  <Avatar alt='My Avatar' src={user.avatarUrl} className={classes.avatar} />
                ) : user.initials !== '' ? (
                  <Avatar alt='My Avatar' className={classes.avatarInitials}>
                    {user.initials}
                  </Avatar>
                ) : (
                  <PersonIcon color='inherit' className={classes.avatarIcon} />
                )}
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMenu}
        {renderMobileMenu}
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  appBar: {
    marginBottom: '25px',
  },
  avatar: {
    width: '40px !important',
    height: '40px !important',
  },
  avatarIcon: {
    fontSize: '18pt',
  },
  avatarInitials: {
    color: theme.palette.type === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
  },
  avatarWrapper: {
    textAlign: 'center',
  },
  userProfileWrapper: {
    textAlign: 'right',
    //paddingRight: '5px',
  },
  companyName: {
    fontSize: '11pt',
  },
  userName: {
    fontWeight: 600,
    fontSize: '10pt',
    paddingTop: '10px',
  },
  userEmail: {
    fontSize: '8pt',
  },
  changeText: {
    fontSize: '8pt',
    marginTop: '-2px',
  },
  menuItem: {
    textAlign: 'Right',
  },
  menuItemButton: {
    alignItems: 'center',
  },
  headerIcon: {
    //fontSize: '18pt'
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  iconButton: {
    color: theme.palette.common.white,
  },
});

export default withRouter(withStyles(styles, { withTheme: true })(observer(Header)));
